import { httpCreate } from './http';

const http = httpCreate('/srv/userEmpower');

export const userEmpower = {
	// 获取用户授权信息
	getByUser() {
		return http.get('/getByUser');
	},
	convert(activityId) {
		return http.post(`/convert/${activityId}`);
	},
	convertReplay(activityId) {
		return http.post(`/convertReplay/${activityId}`);
	},
	// 获取用户警告列表
	getWarnList(params) {
		return http.get('/warning', { params });
	},
	// 获取用户存储空间授权记录
	getUserSpaceList(params) {
		return http.get('/userSpaceList', { params });
	},
	// 获取直播间警告列表
	getActivityWarnList(activityId, params) {
		return http.get(`/warning/${activityId}`, { params });
	},
	// 获取指定userId的授权信息
	getEmpowerTypeForUserId(userId, params) {
		return http.get(`/empowerType/${userId}`, { params });
	},
	getPhotoByUser() {
		return http.get('/photo/getByUser');
	},
};
